import type { EventInfoSectionProps } from '@/lib/types/events.types';
import { AddEventToCalendar } from '@/components/AddEventToCalendar';
import { EventDetailsContent } from '@/content/EventDetailsContent';
import { getEventDescriptionRenderHtml } from '@/lib/utils/event-description.utils';

export function EventInfoSection({ event }: EventInfoSectionProps) {
  const descriptionHtml = getEventDescriptionRenderHtml(event);

  return (
    <div data-testid="event-info-section" className="py-6">
      <div className="flex items-center justify-between mb-4">
        <h2 className="font-field-54 text-h2 text-purple-300">
          {EventDetailsContent.eventInfo}
        </h2>
        <AddEventToCalendar event={event} />
      </div>

      {descriptionHtml ? (
        <div
          className="text-body text-slate-50 break-words [overflow-wrap:anywhere] [&_p]:mb-4 [&_p:last-child]:mb-0 [&_h1]:mb-3 [&_h1]:font-field-74 [&_h1]:text-h1 [&_h2]:mb-3 [&_h2]:font-field-64 [&_h2]:text-h2 [&_h3]:mb-3 [&_h3]:font-field-64 [&_h3]:text-large [&_ul]:mb-4 [&_ul]:list-disc [&_ul]:pl-6 [&_ol]:mb-4 [&_ol]:list-decimal [&_ol]:pl-6 [&_li]:mb-2 [&_a]:text-sky-400 [&_a]:underline [&_a]:underline-offset-4"
          dangerouslySetInnerHTML={{ __html: descriptionHtml }}
        />
      ) : (
        <div className="text-body text-slate-50 space-y-2">
          <p>No details available.</p>
        </div>
      )}
    </div>
  );
}
